/* eslint-disable @tencent/i18next/no-literal-string */

import type { ContentTreeNode } from './content-tree';

export enum TextAreaType {
    Title = 'title', // 标题
    Content = 'content', // 正文
}

export class TextLeafNode {
    // 文字内容
    public text: string;
    // 深度
    public level: number;
    // 对应的内容块
    public contentBlock: ContentTreeNode;
    // 是否是标题
    public titleOrContent: TextAreaType;

    public constructor(text: string, contentBlock: ContentTreeNode) {
        this.text = text;
        this.contentBlock = contentBlock;
        this.level = 0;
        this.titleOrContent = TextAreaType.Content;
    }

    public toMarkdownString(): string {
        const preTitleString = this.titleOrContent === TextAreaType.Title ? '(标题)' : '(正文)';
        let preDepthString = '';
        for (let i = 0; i <= this.level; i++) {
            preDepthString += '#';
        }
        return preTitleString + preDepthString + this.text;
    }

    public setTitleOrContent(titleHeight: number) {
        const rect = this.contentBlock.getRect();
        if (rect.top + rect.height <= titleHeight + 30) {
            this.titleOrContent = TextAreaType.Title;
        }
    }
}
